import Vue from 'vue';
import CardCompare from '@/components/cards/CardCompare.vue';
import CardProduct from '@/components/cards/CardProduct.vue';
import SectionHeader from '@/components/common/SectionHeader.vue';
import Tab from '@/components/common/Tab.vue';
import Tabs from '@/components/common/Tabs.vue';
import TheModal from '@/components/common/TheModal.vue';
import ThePagination from '@/components/common/ThePagination.vue';

Vue.component(CardCompare.name, CardCompare);
Vue.component(CardProduct.name, CardProduct);
Vue.component(SectionHeader.name, SectionHeader);
Vue.component(Tab.name, Tab);
Vue.component(Tabs.name, Tabs);
Vue.component(TheModal.name, TheModal);
Vue.component(ThePagination.name, ThePagination);
